import React, { useCallback, useEffect } from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { PageErrorIconContainerStyled, PageErrorLinkStyled } from "./styled/PageErrorStyled";
import BinIcon from "../components/icon/Icon";
import appHistory from "./appHistory";
import { logAction } from "./appActions";
import { ILogAction } from "./types/appActions.t";


export interface IPageErrorContent { 
    children?: JSX.Element | JSX.Element[];
    code?: number;
    description?: string; 
    error?: null | Error | boolean;
    headerText?: string;
    icon?: string;
    iconComponent?: JSX.Element;
    linkText?: string;
}   
interface IPageErrorContentConetted extends  IPageErrorContent { 
    logAction: (payload: ILogAction) => void;
}
const PageErrorContent = (props: IPageErrorContentConetted) => {
    const {
        children,
        code = 404,
        description,
        error = null,
        headerText = 'Page not found',
        icon = 'IcUnknownError',
        iconComponent,
        linkText = 'Go back to previous page',
        logAction,
    } = props;

    useEffect(() => {
        logAction({
            page: 'error',
            code,
            headerText,
            location: window.location,
            error,
        });
    }, [logAction, code, headerText, error]);
    const handleClick = useCallback(() => appHistory.goBack(), [])

    return <div className="d-flex flex-column align-items-center">
        {
            iconComponent || (
                <PageErrorIconContainerStyled className="mb-3">
                    <BinIcon name={icon} style={{fontSize: '48px'}}/>
                </PageErrorIconContainerStyled>
            )
        }
        <h1 className="mb-4 text-center">{headerText}</h1>
        {!!description && <p className="text-center" dangerouslySetInnerHTML={{__html: description}}/>}
        {
            children || (
                <PageErrorLinkStyled onClick={handleClick}>
                    {linkText}
                </PageErrorLinkStyled>
            )
        }
    </div>
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    logAction: (payload: ILogAction) => dispatch(logAction(payload)),
});

export default connect(null, mapDispatchToProps)(PageErrorContent);
